export const CHANGE_TAB_1 = 'list/CHANGE_TAB_1';
export const CHANGE_TAB_2 = 'list/CHANGE_TAB_2';
export const CHANGE_TAB_3 = 'list/CHANGE_TAB_3';
export const CHANGE_TAB_4 = 'list/CHANGE_TAB_4';
export const CHANGE_TAB_2_ARR = 'list/CHANGE_TAB_2_ARR';
export const CHANGE_TAB_3_ARR = 'list/CHANGE_TAB_3_ARR';
export const CHANGE_TAB_4_ARR = 'list/CHANGE_TAB_4_ARR';
export const CHANGE_TAB_2_ARR_TELL = 'list/CHANGE_TAB_2_ARR_TELL';
export const SET_LOADER = 'list/SET_LOADER';
export const SET_PAGE = 'list/SET_PAGE';
export const SET_TOTAL = 'list/SET_TOTAL';
export const CHANGE_LIST = 'list/CHANGE_LIST';























